import { createContext } from "react";

export interface IAuthContext {
  login: (postLoginRedirectUri: string, scopesToConsent: Array<string>) => void;
  isAuthenticated: boolean;
  isAuthflowCompleted: boolean;
  isFetching: boolean;
  account: any;
}

export const AuthContext = createContext<IAuthContext | undefined>(undefined);
